export interface UsageSummary {
  pipelineId: number;
  pipelineSeqId: number;
  sourceName: string;
  sourceType: string;
  destinationName: string;
  destinationType: string;
  isDeleted: boolean;
  status: { color_type: string };
  pipelineType: UsageSummaryPipelineType;
  region: string;
  events: number[];
}

export interface UsageSummaryBillingCycle {
  label: string;
  startTime?: number;
  endTime?: number;
  count?: number;
}

export enum UsageSummaryPipelineType {
  EDGE = 'EDGE',
  STANDARD = 'STANDARD'
}

export const USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA = {
  [UsageSummaryPipelineType.EDGE]: 'Edge',
  [UsageSummaryPipelineType.STANDARD]: 'Standard'
};
